import routes from '@/modules/place/place-routes';
import store from '@/modules/place/place-store';

export default {
  routes,
  store,
};
